/**
 * TipoOcorrenciaCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {TipoOcorrencia} from '@/model/resource/TipoOcorrencia'

/* TODO: review generated class */
@HttpExclude()
export class TipoOcorrenciaCollection extends PageCollection<TipoOcorrencia> {
  constructor() {
    super(TipoOcorrencia)
  }

  queryAsPage() {
    return this.listTipoOcorrencia()
  }

  async listTipoOcorrencia() {
    return await Request.get(`/admin/tipo-ocorrencia`, {params: this.params})
      .name('listTipoOcorrencia')
      .as(this)
      .getResponse()
  }

  async listCsvTipoOcorrencia() {
    return await Request.get(`/admin/tipo-ocorrencia/csv`, {
      params: this.params,
    })
      .name('listCsvTipoOcorrencia')
      .as(this)
      .getResponse()
  }
}
